import { Main } from '../components/sections/authentication/Main'

export const Authentication = () => {
  return (
    <Main/>
  )
}
